import React from "react";
import "./SetPasswordReminderModal.css";

const SetPasswordReminderModal = ({ isOpen, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div className="set-password-reminder-modal-overlay">
      <div className="set-password-reminder-modal">
        <div className="set-password-reminder-icon">🔐</div>
        <h2 className="set-password-reminder-title">Set Your Password</h2>
        <p className="set-password-reminder-message">
          Please set a permanent password to continue using your account.
        </p>
        <button className="set-password-reminder-btn" onClick={onContinue}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default SetPasswordReminderModal;
